/* eslint-disable */
const $ = jQuery.noConflict();
let autocomplete;
let address1Field;
// let address2Field;
let postalField;
('use strict');
const LocationAutocompleteBilling = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	initAutocomplete() {
		address1Field = document.querySelector('#billing_address_1');
		if (!address1Field) {
			return false;
		}
		postalField = document.querySelector('#billing_postcode');

		// code to be trigger when next/previous page is loaded
		// address2Field = document.querySelector('#address2');
		// Create the autocomplete object, restricting the search predictions to
		// addresses in the US and Canada.
		// eslint-disable-next-line no-undef
		autocomplete = new google.maps.places.Autocomplete(address1Field, {
			componentRestrictions: {country: ['us', 'ca']},
			fields: ['address_components', 'geometry'],
			types: ['address'],
		});
		address1Field.focus();
		// When the user selects an address from the drop-down, populate the
		// address fields in the form.
		autocomplete.addListener(
			'place_changed',
			LocationAutocompleteBilling.fillInAddress
		);
	},

	fillInAddress() {
		// Get the place details from the autocomplete object.
		const place = autocomplete.getPlace();
		let address1 = '';
		let postcode = '';
		// args: string type, boolean bubbles, boolean cancelable
		// Get each component of the address from the place details,
		// and then fill-in the corresponding field on the form.
		// place.address_components are google.maps.GeocoderAddressComponent objects
		// which are documented at http://goo.gle/3l5i5Mr
		for (const component of place.address_components) {
			const componentType = component.types[0];
			const city = document.querySelector('#billing_city');
			const state = document.querySelector('#billing_state');
			const country = document.querySelector('#billing_country');
			// eslint-disable-next-line default-case
			switch (componentType) {
				case 'street_number': {
					console.log(place);
					address1 = place.address_components[0].long_name;
					break;
				}

				case 'route': {
					address1 += ' ' + component.long_name;
					break;
				}

				case 'postal_code': {
					postcode = `${component.long_name}${postcode}`;
					break;
				}

				case 'postal_code_suffix': {
					postcode = `${postcode}-${component.long_name}`;
					break;
				}
				case 'locality':
					document.querySelector('#billing_city').value =
						component.long_name;
					city.value = component.long_name;
					break;
				case 'administrative_area_level_1': {
					if ($('body.woocommerce-checkout').length > 0) {
						if (state.tagName === 'SELECT') {
							$(state).val(component.short_name).trigger('change');
						} else {
							state.value = component.short_name;
						}
						break;
					} else {
						// Ensure the country selection triggers the AJAX request before setting the state
						$(document).ajaxComplete(function(event, xhr, settings) {
							if (settings.data && settings.data.includes('action=cf7_get_states')) {
								if (state.tagName === 'SELECT') {
									setTimeout(function() {
											$(state).val(component.short_name).trigger('change');
										},
										100
									);
								} else {
									state.value = component.short_name;
								}
								$(document).off('ajaxComplete'); // Remove the event listener after setting the state
							}
						});

						break;
					}
				}
				case 'country':
					if (state.tagName === 'SELECT') {
						$(country).val(component.short_name).trigger('change');
					} else {
						country.value = component.short_name;
					}
					break;
			}
		}
		console.log(address1);
		address1Field.value = address1;
		postalField.value = postcode;
		if ($('#billing_city').val) {
			$('#billing_city_field label').addClass('is-moved');
		} else {
			$('#billing_city_field label').removeClass('is-moved');
		}
		if ($('#billing_postcode').val) {
			$('.contact-us__form-wrap--zip label').addClass('is-moved');
		} else {
			$('.contact-us__form-wrap--zip label').removeClass('is-moved');
		}
		const selectedValues = $('select').val();
		if (
			selectedValues &&
			selectedValues !== null &&
			selectedValues.length > 0
		) {
			$('#billing_country label').addClass('is-moved');
			$('#billing_state_field label').addClass('is-moved');
			$('#billing_state').parent().parent().find('label').addClass('is-moved');
			$('#billing_postcode').parent().parent().find('label').addClass('is-moved');
			$('#billing_country').parent().parent().find('label').addClass('is-moved');
			$('#billing_city').parent().parent().find('label').addClass('is-moved');
		} else {
			$('#billing_country label').removeClass('is-moved');
			$('#billing_state_field label').removeClass('is-moved');
			$('#billing_state').parent().parent().find('label').removeClass('is-moved');
			$('#billing_postcode').parent().parent().find('label').removeClass('is-moved');
			$('#billing_city').parent().parent().find('label').addClass('is-moved');
		}

		// Trigger change event so CF7 recognizes the update
		$('#billing_city').trigger('change');
		$('#billing_postcode').trigger('change');

		// Remove CF7 validation errors if fields are filled
		if ($('#billing_city').val()) {
			$('#billing_city').closest('.wpcf7-form-control-wrap').find('.wpcf7-not-valid-tip').remove();
			$('#billing_city').removeClass('wpcf7-not-valid');
			document.querySelector('#billing_city').setCustomValidity(''); // Reset HTML5 validation
		}

		if ($('#billing_postcode').val()) {
			$('#billing_postcode').closest('.wpcf7-form-control-wrap').find('.wpcf7-not-valid-tip').remove();
			$('#billing_postcode').removeClass('wpcf7-not-valid');
			document.querySelector('#billing_postcode').setCustomValidity(''); // Reset HTML5 validation
		}
	},
};

export default LocationAutocompleteBilling;
